import { Alert } from '@mui/material';
import { AdviseCurrentSupplier, AdviseSupplierInvoice } from '../../../../types/advise';

export interface InvoiceBaselineNoticeProps {
  supplier: AdviseCurrentSupplier;
  invoice: AdviseSupplierInvoice;
}

/** Why changes on this invoice leave the amounts below alone, when they do. */
export const InvoiceBaselineNotice = ({ supplier, invoice }: InvoiceBaselineNoticeProps) => {
  if (supplier.spend_entry === 'monthly_total') {
    return (
      <Alert severity="info">
        This supplier&apos;s spend is its hand-entered monthly total, so its invoices&apos; scope, categories and taxes
        don&apos;t change the amounts below.
      </Alert>
    );
  }
  if (invoice.id === supplier.most_recent_invoice_id) return null;
  return (
    <Alert severity="info">
      Only the supplier&apos;s most recent invoice sets its baseline, so this invoice&apos;s scope and categories
      don&apos;t change the amounts below. Include taxes &amp; surcharges applies to the most recent invoice&apos;s
      taxes.
    </Alert>
  );
};
